import { mapState } from "vuex"
import { mapSetter } from "@/plugins/vuexUtils.js"
import eventBus from "@/plugins/eventBus.js"

export default {
  methods: {
    showPageUser: function() {
      eventBus.$emit('busShowPageUser', true)
    },
    addFriend: function(user) {
      eventBus.$emit('busAddFriend', user);
      eventBus.$emit('busUiShow', "manageFriendsFloatShow");
    },
    addBookmark: function(obj) {
      eventBus.$emit('busAddBookmark', obj);
      eventBus.$emit('busUiShow', "manageBookmarkFloatShow");
    },
    togglePresentationMode: function() {
      this.presentationMode = !this.presentationMode;
    },
    setPresentationMode: function(flag) {
      this.presentationMode = flag;
    },
    escapePresentationMode: function() {
      this.presentationMode = false
    },
    resetFoldersInfoFolderIndex: function(folderName) {
      let filtered = Object.entries(this.loginUser.foldersInfo).filter(item => {
        if(item[1].folder == folderName) return true;
        else return false;
      }).sort((a,b) => {
        return b[1].index - a[1].index
      });
      filtered.forEach((item,index) => {
        this.$set(this.loginUser.foldersInfo[item[0]], "index", index);
      })
    },


    // to delete
    getLoginUserDeviceArrayByFolder: function(folderName) {
      let result = [];
      if(folderName == "@admin") {
        if(this.adminDevices) {
          this.adminDevices.forEach(device => {
            result.push(device);
          });
        }
        this.$log.debug(result);
      }
      else {
        if(this.loginUser && !this.loginUserBinded) {
          for(let deviceId in this.loginUser.foldersInfo) {
            if(this.loginUser.foldersInfo[deviceId].folder == folderName) {
              result.push((this.loginUserDeepBinding)? this.loginUser.devices[deviceId] : deviceId);
            }
          }
        }
      }
      return result;
    },

    // to delete
    getloginUserDeviceInfoArrayByFolder: function(folderName) {
      let result = [];
      if(folderName == "@admin") {
        if(this.adminDevices != null) {
          this.adminDevices.forEach((device,index) => {
            result.push({
              "id": device.id,
              "name": device.name,
              "index": index
            });
          });
        }
      }
      else {
        if(this.loginUser != null && this.loginUserBinded) {
          for(let deviceId in this.loginUser.foldersInfo) {
            if(this.loginUser.foldersInfo[deviceId].folder == folderName) {
              result.push(this.loginUser.foldersInfo[deviceId]);
            }
          }
        }
      }
      return result;
    },

    deviceSensorsLastModifiedDateString: function(device) {
      return this.lastModifiedToString(this.deviceSensorsLastModified(device));
    },

    deviceSensorsLastModified: function(device) {
      let result = { seconds: -1 };
      if(device) {
        for(let sensorName in device.sensors) {
          if(device.sensors[sensorName]) {
            if(device.sensors[sensorName].lastValuesModified != null && device.sensors[sensorName].lastValuesModified.seconds > result.seconds) {
              result = device.sensors[sensorName].lastValuesModified;
            }
          }
        }
      }
      return result;
    },
    deviceSensorsRowCount : function(device) {
      let result = 0;
      if(device) {
        for(let sensorName in device.sensors) {
          if(device.sensors[sensorName]) {
            result += (device.sensors[sensorName].lastBook*1000 + device.sensors[sensorName].lastIndex + 1);
          }
        }
      }
      return result;
    },
    lastModifiedToString: function(lastModified) {
      if(lastModified == null || lastModified.seconds == -1) {
        return "없음";
      }
      else {
        return this.dateToString(lastModified.toDate());
      }
    },
    deviceListLastModifiedDateString: function(list) {
      let lastModified = { seconds: -1 };
      list.forEach(deviceItem => {
        let temp = this.deviceSensorsLastModified(deviceItem);
        if(temp.seconds > lastModified.seconds) {
          lastModified = temp;
        }
      })
      return this.lastModifiedToString(lastModified);
    },

    folderLastModifiedDateString: function(folderName) {
      let lastModified = { seconds: -1 };
      if(folderName == "@admin") {
        if(this.isLoginUserPageUser && this.adminDevices != null) {
          this.adminDevices.forEach(deviceItem => {
            let temp = this.deviceSensorsLastModified(deviceItem);
            if(temp.seconds > lastModified.seconds) {
              lastModified = temp;
            }
          });
        }
      }
      else {
        for(let deviceInfo in this.pageUser.foldersInfo) {
          if(deviceInfo.folder == folderName) {
            let temp = this.deviceSensorsLastModified(this.pageUser.devices[deviceInfo.id]);
            if(temp.seconds > lastModified.seconds) {
              lastModified = temp;
            }
          }
        }
      }
      return this.lastModifiedToString(lastModified);
    },
    openNewGmapWindow: function(lat, lng) {
      window.open("https://maps.google.com/?q=" + lat + "," + lng)
    },

    isIdPageUserFriend: function(uid) {
      if(this.pageUser == null) return false;
      else if(!this.pageUser.disabled && this.pageUser.frApp.some((value) => { return value == uid })) {
        return true
      }
      else {
        return false
      }
    },

    isIdLoginUserFriend: function(uid) {
      if(this.loginUser == null) return false;
      else if(this.loginUserBinded && !this.loginUser.disabled && this.loginUser.frApp.some((value,index,array) => { return value == uid })) {
        return true
      }
      else {
        return false
      }
    },

    isLoginUserItemReadable: function(item) {
      if(!this.loginUserBinded) return false;
      else if(!item) return false;
      else if(this.isLoginUserAdmin) return true;
      else if(item.open) return true;
      else if(this.isLoginUserItemAdmin(item)) return true;
      else if(this.isLoginUserItemOAdmin(item)) return true;
      else if(this.isLoginUserItemOwner(item)) return true;
      else if(this.isLoginUserItemFriend(item)) return true;
      else return false;
    },

    isLoginUserItemWritable: function(item) {
      if(!this.loginUserBinded) return false;
      else if(!item) return false;
      else if(this.isLoginUserAdmin) return true;
      else if(this.isLoginUserItemAdmin(item)) return true;
      else if(this.isLoginUserItemOwner(item)) return true;
      else return false;
    },

    isLoginUserItemOAdmin: function(item) {
      if(this.loginUserBinded && item && typeof(item.oAdmin) != "undefined" && this.loginUser.id == item.oAdmin) return true
      else return false
    },

    isLoginUserItemAdmin: function(item) {
      if(this.loginUserBinded && item && typeof(item.admin) != "undefined" && this.loginUser.id == item.admin) return true
      else return false
    },

    isLoginUserDeviceOAdmin: function(device) {
      if(this.loginUserBinded && device && typeof(device.oAdmin) != "undefined" && this.loginUser.id == device.oAdmin) return true
      else return false
    },

    isLoginUserItemOwner: function(item) {
      if(this.loginUserBinded && item && typeof(item.owner) != "undefined" && this.loginUser.id == item.owner) {
         return true
      }
      else {
        return false
      }
    },

    isLoginUserItemFriend: function(item) {
      if(this.loginUserBinded && item && typeof(item.frApp) != "undefined" && item.frApp.some((value,index,array) => { return value == this.loginUser.id })) return true
      else return false
    },

    searchLoginUserSensorAll: function(sid) {
      let found = null;
      for(let i=0;i<this.loginUserSensorArrayAll.length;i++) {
        if(this.loginUserSensorArrayAll[i].id == sid) {
          found = this.loginUserSensorArrayAll[i];
          break;
        }
      }
      return found;
    },

    searchLoginUserSensor: function(sid) {
      let found = null;
      for(let i=0;i<this.loginUserSensorArray.length;i++) {
        if(this.loginUserSensorArrayAll[i].id == sid) {
          found = this.loginUserSensorArray[i];
          break;
        }
      }
      return found;
    },

  },
  computed: {

    countDevicesForMap: function(){

      if(this.isLoginUserPageUser&&this.loginUserDeepBinding) {
        return this.loginUserDeviceArrayAll.filter(item=>{
          return item.location != null && typeof(item.deleteScheduledTime) == "undefined"
        }).length;
      }
      else {
        return this.pageUserDeviceArrayAll.filter(item=>{
          return item.location != null && typeof(item.deleteScheduledTime) == "undefined"
        }).length;
      }
    },

    pageUserDeviceGroupByFolder: function() {
      let result = {};
      if(!this.pageUser) {
        return result;
      }
      else {
        if(this.pageUser.folders) {
          this.pageUser.folders.forEach(folder=> {
            result[folder] = [];
          })
        }
        result["@root"] = [];
        for(let device in this.pageUser.devices) {
          result[(this.pageUser.foldersInfo && this.pageUser.foldersInfo[device].folder)? this.pageUser.foldersInfo[device].folder: "@root"].push(this.pageUser.devices[device]);
        }
        return result;
      }
    },

    pageUserDeviceInfoGroupByFolder: function() {
        let result = {};
        if(!this.pageUser) {
          return result;
        }
        else {
          this.pageUser.folders.forEach(folder=> {
            result[folder] = [];
          })
          result["@root"] = [];
          for(let device in this.pageUser.foldersInfo) {
            if(this.pageUser.foldersInfo[device].folder == "") {
              if(this.pageUser.foldersInfo[device].name) {
                result["@root"].push({
                  id: device,
                  name: this.pageUser.foldersInfo[device].name,
                  index: this.pageUser.foldersInfo[device].index,
                });
              }
              else {
                result["@root"].push({
                  id: device,
                  index: this.pageUser.foldersInfo[device].index,
                });
              }
            }
            else if(typeof(result[this.pageUser.foldersInfo[device].folder]) != "undefined") {
              if(this.pageUser.foldersInfo[device].name) {
                result[this.pageUser.foldersInfo[device].folder].push({
                  id: device,
                  name: this.pageUser.foldersInfo[device].name,
                  index: this.pageUser.foldersInfo[device].index
                });
              }
              else {
                result[this.pageUser.foldersInfo[device].folder].push({
                  id: device,
                  index: this.pageUser.foldersInfo[device].index
                });
              }
            }
            else {
              if(this.pageUser.foldersInfo[device].name) {
                result["@root"].push({
                  id: device,
                  index: this.pageUser.foldersInfo[device].index,
                  name: this.pageUser.foldersInfo[device].name,
                  error: true
                });
              }
              else {
                result["@root"].push({
                  id: device,
                  index: this.pageUser.foldersInfo[device].index,
                  error: true
                });
              }
            }
          }
          if(result["@root"].length !=0) {
            result["@root"] = result["@root"].sort((a,b)=> a.index-b.index);
            result["@root"].forEach((item, position) => {
              item.index = position;
              this.pageUser.foldersInfo[item.id].index = position;
            })
          }
          this.pageUser.folders.forEach(folder=> {
            if(result[folder].length !=0) {
              result[folder] = result[folder].sort((a,b)=> a.index-b.index);
              result[folder].forEach((item, position) => {
                item.index = position;
                this.pageUser.foldersInfo[item.id].index = position;
              })
            }
          })
          return result;
        }
    },

    pageUserDeviceList: function() {
      let result = {};
      if(!this.pageUser) {
        return result;
      }
      else {
        for(let deviceId in this.pageUser.devices) {
          result[deviceId] = this.pageUser.devices[deviceId];
        }
        return result;
      }
    },

    pageUserDeviceListAll: function() {
      let result = this.pageUserDeviceList;
      if(this.adminDevices != null && this.isLoginUserPageUser) {
        this.adminDevices.forEach(device => {
          result[device.id] = device;
        })
      }
      return result;
    },

    pageUserDeviceArray: function() {
      let result = [];
      if(!this.pageUser) {
        return result;
      }
      for(let deviceId in this.pageUser.devices) {
        result.push(this.pageUser.devices[deviceId]);
      }
      return result;
    },

    pageUserDeviceArrayAll: function() {
      let result = this.pageUserDeviceArray;
      if(this.adminDevices != null && this.isLoginUserPageUser) {
        result = result.concat(this.adminDevices);
      }
      return result;
    },

    pageUserSensorArray: function() {
      let result = [];
      for(let device in this.pageUserDeviceList) {
        for(let sensorName in this.pageUserDeviceList[device].sensors) {
          result.push(this.pageUserDeviceList[device].sensors[sensorName]);
        }
      }
      return result;
    },

    pageUserSensorArrayAll: function() {
      let result = [];
      this.pageUserDeviceArrayAll.forEach(device => {
        for(let sensorName in device.sensors) {
          result.push(device.sensors[sensorName]);
        }
      })
      return result;
    },

    pageUserSensorArrayHasData: function() {
      return this.pageUserSensorArray.filter(sensor=> sensor.lastValues != null);
    },

    pageUserSensorArrayAllHasData: function() {
      return this.pageUserSensorArrayAll.filter(sensor=> sensor.lastValues != null);
    },

    loginUserDeviceGroupByFolder: function() {
      let result = {};
      if(!this.loginUser) {
        return result;
      }
      else {
        return this.$store.getters.loginUserDeviceGroupByFolder;
      }
    },

    loginUserDeviceInfoGroupByFolder: function() {
      let result = {};
      if(!this.loginUser) {
        return result;
      }
      else {
        return this.$store.getters.loginUserDeviceInfoGroupByFolder;
      }
    },

    loginUserDeviceArrayAll: function() {
      if(!this.loginUser) {
        return [];
      }
      else {
        return this.$store.getters.loginUserDeviceArrayAll;
      }
    },

    loginUserDeviceArray: function() {
      if(!this.loginUser) {
        return [];
      }
      else {
        return this.$store.getters.loginUserDeviceArray;
      }
    },

    loginUserDeviceListAll: function() {
      if(!this.loginUser) {
        return [];
      }
      else {
        return this.$store.getters.loginUserDeviceListAll;
      }
    },

    loginUserAdminDeviceList: function() {
      if(!this.loginUser) {
        return {};
      }
      else {
        return this.$store.getters.loginUserAdminDeviceList;
      }
    },

    loginUserDeviceList: function() {
      if(!this.loginUser) {
        return {};
      }
      else {
        return this.$store.getters.loginUserDeviceList;
      }
    },

    loginUserSensorArrayAll: function() {
      if(!this.loginUser) {
        return [];
      }
      else {
        return this.$store.getters.loginUserSensorArrayAll;
      }
    },

    loginUserSensorArrayAllHasData: function() {
      if(!this.loginUser) {
        return [];
      }
      else {
        return this.$store.getters.loginUserSensorArrayAllHasData;
      }
    },

    loginUserSensorArray: function() {
      if(!this.loginUser) {
        return [];
      }
      else {
        return this.$store.getters.loginUserSensorArray;
      }
    },

    loginUserSensorArrayHasData: function() {
      if(!this.loginUser) {
        return [];
      }
      else {
        return this.$store.getters.loginUserSensorArrayHasData;
      }
    },

    loginUserFrReqArray: function() {
      return Object.entries(this.loginUser.frReq);
    },

    isLoginUserPageUser: function() {
      if(!this.loginUserBinded) return false;
      else if(this.loginUser.id == this.pageUser.id) {
        return true;
      }
      else {
        return false;
      }
    },

    isLoginUserAdmin: function() {
      if(!this.loginUserBinded) return false;
      else {
        if(this.loginUser.email == process.env.VUE_APP_ADMIN_EMAIL) {
          return true
        }
        else {
          return false
        }
      }
    },

    isPageUserWithdrawn: function() {
      if(!this.pageUser) return false;
      else if(typeof(this.pageUser.withdrawn) == "undefined") return false;
      else if(this.pageUser.withdrawn) return true;
      else return false;
    },

    isLoginUserPageUserReadable: function() {
      if(!this.loginUserBinded) return false;
      else if(!this.pageUser) return false;
      else if(this.isLoginUserAdmin) return true;
      else if(this.isLoginUserPageUser) return true;
      else if(this.pageUser.open) return true;
      else if(this.isIdPageUserFriend(this.loginUser.id)) return true;
      else return false;
    },

    isLoginUserPageUserWritable: function() {
      if(!this.loginUserBinded) return false;
      else if(!this.pageUser) return false;
      else if(this.isLoginUserAdmin) return true;
      else if(this.isLoginUserPageUser) return true;
      else return false;
    },

    isLoginUserPageItemReadable: function() {
      return this.isLoginUserItemReadable(this.pageDevice);
    },

    isLoginUserPageItemWritable: function() {
      return this.isLoginUserItemWritable(this.pageDevice);
    },

    isLoginUserPageItemAdmin: function() {
      return this.isLoginUserItemAdmin(this.pageDevice);
    },

    isLoginUserPageDeviceOAdmin: function() {
      return this.isLoginUserDeviceOAdmin(this.pageDevice);
    },

    isLoginUserPageItemOwner: function() {
      return this.isLoginUserItemOwner(this.pageDevice);
    },

    isLoginUserPageItemFriend: function() {
      return this.isLoginUserItemFriend(this.pageDevice);
    },

    ...mapSetter(
      mapState({
        loginUser: state => state.loginUser,
        loginUserBinded: state => state.loginUserBinded,

        adminDevices: state => state.adminDevices,
        adminDevicesBinded: state => state.adminDevicesBinded,

        oAdminDevices: state => state.oAdminDevices,
        oAdminDevicesBinded: state => state.oAdminDevicesBinded,

        friendDevices: state => state.friendDevices,
        friendDevicesBinded: state => state.friendDevicesBinded,

        loginUserOpen: state => state.loginUserOpen,
        loginUserDeepBinding: state => state.loginUserDeepBinding,
        notLoginConfirmed: state => state.notLoginConfirmed,
        presentationMode: state => state.presentationMode,
        showPresentationModeEscapeButton: state => state.showPresentationModeEscapeButton,
      })

    )
  }
}
